module.exports = __webpack_public_path__ + "media/images/photo-vault-ea18ce597352dcc3238c4b501a00d94a.jpg";